module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quote-slider-wrapper carousel slide",
    class: _vm.addclass,
    attrs: {
      "id": "testimonials-carousel"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._t("default"), _vm._v(" "), _vm._m(2)], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "slider-arrow slider-left",
    attrs: {
      "href": "#testimonials-carousel",
      "role": "button",
      "data-slide": "prev"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/arrowleft.png",
      "alt": "Previous"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "slider-arrow slider-right",
    attrs: {
      "href": "#testimonials-carousel",
      "role": "button",
      "data-slide": "next"
    }
  }, [_c('img', {
    attrs: {
      "src": "images/arrowright.png",
      "alt": "Next"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "carousel-bottom"
  }, [_c('ol', {
    staticClass: "carousel-indicators"
  }, [_c('li', {
    staticClass: "active",
    attrs: {
      "data-target": "#testimonials-carousel",
      "data-slide-to": "0"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#testimonials-carousel",
      "data-slide-to": "1"
    }
  }), _vm._v(" "), _c('li', {
    attrs: {
      "data-target": "#testimonials-carousel",
      "data-slide-to": "2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0fa809d8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/Testimonials.vue
// module id = 3BHV
// module chunks = 1